import React from "react";
import { epiPropertyValue } from "@avensia/nitro5-scope-episerver";
import ViewTracker from "Shared/ViewObserver/ViewTracker";
import { promoImpression, promoClick, } from "../../../../../TrackingInformation";
const toPromo = (marketingAd) => {
    return {
        id: "block-" + epiPropertyValue(marketingAd.blockId),
        name: epiPropertyValue(marketingAd.header) ||
            epiPropertyValue(marketingAd.blockName),
        creative: epiPropertyValue(marketingAd.image),
        position: "QuickSearch",
    };
};
export function onClick(event, marketingAd) {
    promoClick(toPromo(marketingAd));
}
export default function MarketingAdViewTracker({ children, item }) {
    const onView = (visible, marketingAd) => {
        if (!visible || !!!marketingAd)
            return;
        promoImpression(toPromo(marketingAd));
    };
    return (React.createElement(ViewTracker, { key: "autocompleteAdViewTracker", onView: (visible) => onView(visible, item) }, children));
}
